import {
  pgTable,
  uuid,
  text,
  boolean,
  date,
  jsonb,
  timestamp,
  index,
} from "drizzle-orm/pg-core";
import { customers } from "./customers.js";

// Dokobit age-verification records. One row per verification attempt; the
// checkout gate requires a `verified` (or `exempt`) row before an alcohol order
// is created. Personal code is stored hashed only.
export const ageVerifications = pgTable(
  "age_verifications",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    customerId: uuid("customer_id").references(() => customers.id, { onDelete: "set null" }),
    sessionId: text("session_id"),
    provider: text("provider").notNull().default("dokobit"),
    // "pending" until the customer picks a method on Dokobit's hosted page;
    // set to the actual method (e.g. "smartid", "eparaksts_mobile") on complete.
    // "exempt" is used for the per-customer skip-verification audit row.
    method: text("method")
      .notNull()
      .$type<"smartid" | "eparaksts_mobile" | "smartcard" | "exempt" | "pending">(),
    country: text("country").$type<"LV" | "LT" | "EE">(),
    dokobitToken: text("dokobit_token"),
    status: text("status").notNull().default("pending").$type<
      "pending" | "verified" | "failed" | "exempt"
    >(),
    legalAge: boolean("legal_age").notNull().default(false),
    dateOfBirth: date("date_of_birth"),
    fullName: text("full_name"),
    personalCodeHash: text("personal_code_hash"),
    rawResponse: jsonb("raw_response"),
    verifiedAt: timestamp("verified_at", { withTimezone: true }),
    expiresAt: timestamp("expires_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    customerIdx: index("age_verifications_customer_idx").on(t.customerId),
    sessionIdx: index("age_verifications_session_idx").on(t.sessionId),
    tokenIdx: index("age_verifications_token_idx").on(t.dokobitToken),
  }),
);

export type AgeVerification = typeof ageVerifications.$inferSelect;
export type NewAgeVerification = typeof ageVerifications.$inferInsert;
